<template>
  <div>
    <b-table :current-page="currentPage"
             :fields="fields"
             :items="feedbacks"
             :per-page="perPage"
             :sort-by="'states.date'"
             :sort-desc="true"
             class="table-responsive"
             head-variant="light"
             hover
             responsive
             striped>
      <template v-slot:top-row="{fields}">
        <proposal-filter :id="id"
                         v-model="feedbacks"
                         :fields="fields"
                         :not-include-key="['actions','ordinalNumber']"/>
      </template>

      <template v-slot:cell(ordinalNumber)="row">
        <base-column-ordinal-number v-bind="{index: row.index, perPage: perPage, currentPage: currentPage}"/>
      </template>

      <template v-slot:cell(actions)="row">
        <base-action-expand-details v-if="elevated"
                                    :b-table-row="row"/>

        <base-material-design-icon-button v-else
                                          icon="rate_review"
                                          title="Go to feedback"
                                          @click="goToDocument(getId(row.item), row.item.feedbacks.user_id)"/>
      </template>

      <template v-slot:row-details="row">
        <b-card class="ma-4">
          <b-table :fields="feedbackFields"
                   :items="row.item.feedbacks"
                   class="table-responsive"
                   hover
                   responsive>
            <template v-slot:cell(actions)="row">
              <base-material-design-icon-button icon="rate_review"
                                                title="Go to feedback"
                                                @click="goToDocument(row.item.document_id, row.item.user_id)"/>
            </template>
          </b-table>
        </b-card>
      </template>

    </b-table>
    <b-table-footer v-model="loading"
                    :current-page="currentPage"
                    :data-length="feedbacks.length"
                    :per-page="perPage"
                    @change-page="changePage">
      <template v-slot>
        <base-per-page-input v-model="perPage"/>
      </template>
    </b-table-footer>
  </div>
</template>

<script>
  import BaseActionExpandDetails from '@/components/actions/BaseActionExpandDetails';
  import BaseColumnOrdinalNumber from '@/components/base-components/BaseColumnOrdinalNumber';
  import BaseMaterialDesignIconButton from '@/components/base-components/base-icons/BaseMaterialDesignIconButton';
  import BasePerPageInput from '@/components/base-components/BasePerPageInput';
  import BTableFooter from '@/components/BTableFooter';
  import ProposalFilter from '@/components/ProposalFilter';

  export default {
    name: 'FeedbackList',
    props: {
      loadDataUrl: {
        type: String,
        default: '',
      },
      elevated: {
        type: Boolean,
        default: false,
      },
      fields: {
        type: Array,
        default: () => [],
      },
      feedbackFields: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      BaseActionExpandDetails,
      BaseColumnOrdinalNumber,
      BaseMaterialDesignIconButton,
      BasePerPageInput,
      ProposalFilter,
      BTableFooter,
    },
    data() {
      return {
        loading: false,
        currentPage: 1,
        perPage: 20,
        feedbacks: [],
        id: 1,
      };
    },
    methods: {
      loadData() {
        this.loading = true;
        this.axios.get(this.loadDataUrl)
          .then((response) => {
            this.processDocuments(response.data.documents);
            this.feedbacks = response.data.documents;
            this.$emit('setup-proposal', this.feedbacks);
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      processDocuments(documents) {
        if (documents.length >= 0) {
          for (const document of documents) {
            // eslint-disable-next-line camelcase
            document.created_at = this.createdAt(document);
            if (Array.isArray(document.feedbacks)) {
              for (const feedback of document.feedbacks) {
                // eslint-disable-next-line camelcase
                feedback.document_id = this.getId(document);
              }
            }
          }
        }
      },
      changePage(val) {
        this.currentPage = val;
      },
      goToDocument(documentId, userId) {
        this.$router.push(`/feedbacks/${documentId}/${userId}`);
      },
    },
    created() {
      this.loadData();
    },
  };
</script>

<style scoped>

</style>
